import {Drawer} from '@mui/material';
import styled from '@emotion/styled';

export const DrawerDiv = styled(Drawer)`
  .MuiDrawer-paperAnchorRight {
    width: 20%;
    padding: 1rem;
    margin-top: 3rem;
  }
`;
